import { render, staticRenderFns } from "./InvestmentHoldingsIcon.vue?vue&type=template&id=7d512899&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d512899')) {
      api.createRecord('7d512899', component.options)
    } else {
      api.rerender('7d512899', component.options)
    }
    module.hot.accept("./InvestmentHoldingsIcon.vue?vue&type=template&id=7d512899&functional=true&", function () {
      api.rerender('7d512899', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/navbar/icons/InvestmentHoldingsIcon.vue"
export default component.exports